import { deleteData, getData, putData } from './http.ts';

const getSubscriptions = () => {
  return getData({
    url: `${import.meta.env.VITE_SUBSCRIPTION_HUB_URL}/v1/subscriptions`,
  });
};

const deleteSubscription = id => {
  return deleteData({
    url: `${import.meta.env.VITE_SUBSCRIPTION_HUB_URL}/v1/subscriptions/${id}`,
  });
};

const putSubscriptionUser = (id, authorizationCode, redirectUri) => {
  return putData({
    url: `${import.meta.env.VITE_SUBSCRIPTION_HUB_URL}/v1/users/${id}?authorizationCode=${authorizationCode}&redirectUri=${redirectUri}`,
  });
};

export { getSubscriptions, deleteSubscription, putSubscriptionUser };
